<template>
    <v-list
            dense
            nav
    >
        <v-list-item
                link
                :to="{ name: 'SettingsUsers'}"
                active-class="primary--text"
                exact

        >
            <v-list-item-icon >
                <v-icon>mdi-account-box-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Nutzer</v-list-item-title>
        </v-list-item>

        <!--<v-list-item
                link
                :to="{ name: 'SettingsOrgaUnits'}"
                active-class="primary&#45;&#45;text"
                exact
        >
            <v-list-item-icon >
                <v-icon>mdi-google-circles-communities</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Organisationseinheiten</v-list-item-title>
        </v-list-item>-->
    </v-list>
</template>

<script>
    export default {
        computed: {
            active() {
                return [
                    'EmployeeInterviewsIndex',
                    'EmployeeInterviewsEmployees',
                    'EmployeeInterviewsCreate' ,
                    'EmployeeInterviewsEdit'
                ].includes(this.$route.name);
            }
        },
    }
</script>

<style scoped>

</style>